import { render } from "./FilterItem.vue?vue&type=template&id=67bdb4c8&scoped=true"
import script from "./FilterItem.vue?vue&type=script&lang=js"
export * from "./FilterItem.vue?vue&type=script&lang=js"

import "./FilterItem.vue?vue&type=style&index=0&id=67bdb4c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67bdb4c8"]])

export default __exports__